<template>
  <div class="w-full px-6 py-4">
    <o-group :title="$t('minimiseGaps.title')" :info="$t('components.employee.edit.minimiseGaps.info')">
      <template #control>
        <toggle-field v-model="_employee.minimiseGapsSettings.overridden" />
      </template>

      <div>
        <div class="flex space-x-4 mb-4">
          <o-field-group
            class="w-full"
            :label="$t('general.enabled')"
            :name="$t('general.enabled')"
            :info="$t('components.employee.edit.minimiseGaps.enabledInfo')"
            col
            reverse
          >
            <toggle-field v-model="_employee.minimiseGapsSettings.enabled" :disabled="!_employee.minimiseGapsSettings.overridden" />
          </o-field-group>
        </div>

        <div class="flex space-x-4 mb-4">
          <o-field-group
            class="w-full"
            :label="$t('minimiseGaps.showFirstAvailable')"
            :name="$t('minimiseGaps.showFirstAvailable')"
            :info="$t('components.employee.edit.minimiseGaps.showFirstAvailableAppointmentInfo')"
            col
            reverse
          >
            <toggle-field v-model="_employee.minimiseGapsSettings.allowStartOfDay" :disabled="!_employee.minimiseGapsSettings.overridden" />
          </o-field-group>
        </div>

        <div class="flex space-x-4 mb-4">
          <o-field-group
            class="w-full"
            :label="$t('minimiseGaps.showLastAvailable')"
            :name="$t('minimiseGaps.showLastAvailable')"
            :info="$t('components.employee.edit.minimiseGaps.showLastAvailableAppointmentInfo')"
            col
            reverse
          >
            <toggle-field v-model="_employee.minimiseGapsSettings.allowEndOfDay" :disabled="!_employee.minimiseGapsSettings.overridden" />
          </o-field-group>
        </div>

        <div class="flex space-x-4 mb-4">
          <o-field-group
            class="w-full"
            :label="$t('components.employee.edit.minimiseGaps.showAvailabilityBeforeAndAfter')"
            :name="$t('components.employee.edit.minimiseGaps.showAvailabilityBeforeAndAfter')"
            :info="$t('components.employee.edit.minimiseGaps.showAvailabilityBeforeAndAfterInfo')"
            col
            reverse
          >
            <toggle-field v-model="_employee.minimiseGapsSettings.allowAlongsideBlocks" :disabled="!_employee.minimiseGapsSettings.overridden" />
          </o-field-group>
        </div>

        <div class="flex space-x-4 mb-4">
          <o-field-group
            class="w-full"
            :label="$t('minimiseGaps.showAvailabilityLeavingMinGapTime')"
            :name="$t('minimiseGaps.showAvailabilityLeavingMinGapTime')"
            :info="$t('components.employee.edit.minimiseGaps.showAvailabilityLeavingMinGapTimeInfo')"
          >
            <number-field v-model="_employee.minimiseGapsSettings.allowWithMinimumGap" :disabled="!_employee.minimiseGapsSettings.overridden" />
          </o-field-group>
        </div>

        <div class="flex space-x-4 mb-4">
          <o-field-group
            class="w-full"
            :label="$t('minimiseGaps.showAllAvailability')"
            :name="$t('minimiseGaps.showAllAvailability')"
            :info="$t('components.employee.edit.minimiseGaps.showAllAvailabilityForEmptyDayInfo')"
            col
            reverse
          >
            <toggle-field v-model="_employee.minimiseGapsSettings.allowAnyOnEmptyDay" :disabled="!_employee.minimiseGapsSettings.overridden" />
          </o-field-group>
        </div>
      </div>
    </o-group>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import {
  NumberField,
  ToggleField,
} from '@/components/fields'

import {
  OGroup,
} from '@/components/elements'

interface Props {
  employee: Record<string, any>
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:employee', value: Record<string, any>): void
}>()

const _employee = computed({
  get () {
    return props.employee
  },
  set (value) {
    emit('update:employee', value)
  },
})
</script>
